import GroupsGrid from './groups-grid';
import { pagesConfig } from '../../../shared/pages-config';
import { useUserSettings } from '../../../utils/use-user-settings';
import SimpleBreadcrumbsPage from '../../../shared/simple-breadcrumbs-page';
import { ModuleList } from '../../../shared/analytics/module-list';
import GroupsIndexGrid from './group-management/groups-indexed-grid';
import { Outlet, useParams } from 'react-router-dom';
import { isFeatureEnabled } from '../../../utils/feature-flags';
import GroupHealthSettingsGear from './group-management/group-health-settings-gear';

export default function GroupsPage() {
  const { groupEmail } = useParams() as { groupEmail: string | undefined };
  const { viewType, currentTier, features } = useUserSettings();

  if (groupEmail) {
    return <Outlet />;
  }

  return (
    <SimpleBreadcrumbsPage
      breadcrumbs={[
        { label: ModuleList.modules.directory.name },
        { label: pagesConfig.groups.name },
      ]}
      bookmarkKey={pagesConfig.groups.value}
      headerActions={
        currentTier === 'enterprise' &&
        isFeatureEnabled('groupsGovernanceBackend', features) && (
          <GroupHealthSettingsGear />
        )
      }
    >
      {currentTier === 'enterprise' &&
      isFeatureEnabled('indexGroupsReact', features) ? (
        <GroupsIndexGrid
          key={viewType.groupsIndexedGridStates?.activeGridState || 'default'}
        />
      ) : (
        <GroupsGrid
          key={viewType.groupsGridStates?.activeGridState || 'default'}
        />
      )}
    </SimpleBreadcrumbsPage>
  );
}
